import { Stack, Typography } from "@mui/material";
import { CrudLink } from "@/shared/components";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import { PagePaths } from "@/admin/shared/constants";
import { audienceLabel } from "@/admin/entities/assistant";
import type { AssistantUsageRow } from "./types";

function budgetShare(row: AssistantUsageRow): number | null {
  if (!row.budgetUsd) return null;
  return (row.costUsd / row.budgetUsd) * 100;
}

export const getColumnsConfig = (): ColumnDefinition<AssistantUsageRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "audience",
    label: "Аудитория",
    options: {
      sort: false,
      customBodyRender: (value: unknown) =>
        audienceLabel(value as string | null),
    },
  },
  {
    name: "platform",
    label: "Арена",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const row = data as AssistantUsageRow;
        if (!row.platform) return "-";
        return (
          <CrudLink
            path={PagePaths.platforms}
            tab="details"
            id={row.platform.id}
          >
            {row.platform.title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "organization",
    label: "Организация",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const row = data as AssistantUsageRow;
        if (!row.organization) return "-";
        return (
          <CrudLink
            path={PagePaths.organizations}
            tab="details"
            id={row.organization.id}
          >
            {row.organization.title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "month",
    label: "Месяц",
    options: {},
  },
  {
    name: "messages",
    label: "Сообщений",
    options: { sort: false },
  },
  {
    name: "costUsd",
    label: "Стоимость",
    options: {
      sort: false,
      customBodyRender: (value: unknown) =>
        `$${((value as number) ?? 0).toFixed(3)}`,
    },
  },
  {
    name: "budgetUsd",
    label: "Бюджет",
    options: {
      sort: false,
      customBodyRender: (value: unknown) =>
        `$${((value as number) ?? 0).toFixed(2)}`,
    },
  },
  {
    name: "budgetShare",
    label: "Доля бюджета",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const share = budgetShare(data as AssistantUsageRow);
        return share == null ? "-" : `${share.toFixed(1)}%`;
      },
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Расход",
  refetchList: "Обновить список",
});

export const getMobileColumnsConfig =
  (): DataListViewColumns<AssistantUsageRow> => ({
    main: {
      title: "Расход",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <Stack sx={{ minWidth: 0 }}>
          <Typography noWrap>{row.month}</Typography>
          <Typography variant="body2" color="textSecondary" noWrap>
            {row.platform?.title ?? "-"}
          </Typography>
        </Stack>
      ),
    },
    cost: {
      title: "Стоимость",
      sx: { width: 96, flexShrink: 0 },
      renderCell: (row) => `$${(row.costUsd ?? 0).toFixed(3)}`,
    },
  });
